// assets/vehicle-filter.js
(function () {

  const VEHICLE_CACHE_KEY = "vehicleDataCache_v1";
  const VEHICLE_CACHE_TTL_MS = 30 * 60 * 1000;

  async function fetchVehiclePage(cursorParam) {
    const url = `/?sections=vehicle-data-json${cursorParam}&_=${Date.now()}`;
    const res = await fetch(url, { cache: "no-store" });
    if (!res.ok) return null;

    const wrapper = await res.json();
    let rawText = wrapper["vehicle-data-json"];
    rawText = rawText.replace(/^<div[^>]*>/, "").replace(/<\/div>\s*$/, "").trim();
    return JSON.parse(rawText);
  }

  async function loadAllVehicleData() {
    try {
      const cachedRaw = sessionStorage.getItem(VEHICLE_CACHE_KEY);
      if (cachedRaw) {
        const cached = JSON.parse(cachedRaw);
        if (Date.now() - cached.timestamp < VEHICLE_CACHE_TTL_MS) {
          window.vehicleData = cached.items;
          window.vehicleDataLoading = false;
          document.dispatchEvent(new Event("vehicleDataReady"));
          return;
        }
      }
    } catch (e) {
      // ignore cache read errors
    }

    let allData = [];

    try {
      const firstPage = await fetchVehiclePage("");
      if (firstPage && firstPage.items) {
        allData = firstPage.items.slice();

        const totalCount = firstPage.total_count || 0;
        const pageSize = firstPage.page_size || 250;
        const totalPages = Math.ceil(totalCount / pageSize);

        if (totalPages > 1 && firstPage.next_url) {
          const nextUrlObj = new URL(firstPage.next_url, window.location.origin);
          const cursorTemplate = nextUrlObj.search.replace(/^\?/, "");

          const pagePromises = [];
          for (let p = 2; p <= totalPages; p++) {
            const cursorParam = "&" + cursorTemplate.replace(/=\d+$/, `=${p}`);
            pagePromises.push(fetchVehiclePage(cursorParam));
          }

          const results = await Promise.all(pagePromises);
          results.forEach(payload => {
            if (payload && payload.items) {
              allData = allData.concat(payload.items);
            }
          });
        }
      }
    } catch (err) {
      console.error("Vehicle data load error:", err);
    }

    window.vehicleData = allData;
    window.vehicleDataLoading = false;

    try {
      sessionStorage.setItem(VEHICLE_CACHE_KEY, JSON.stringify({ items: allData, timestamp: Date.now() }));
    } catch (e) {
      // sessionStorage full — skip caching
    }

    document.dispatchEvent(new Event("vehicleDataReady"));
  }

  function initFilters() {
    // Check if DOM elements exist
    const wrappers = document.querySelectorAll(".vehicle-filter-wrapper");
    if (wrappers.length === 0) {
      return; // silently return if no wrappers found
    }

    const data = window.vehicleData || [];
    let userModified = false;
    let isAutoFilling = false;

    function applySavedVehicle(wrapper) {
      const savedId = localStorage.getItem("selectedVehicle");
      const savedYear = localStorage.getItem("selectedYear");
      if (!savedId) return;

      const vehicle = data.find(v => v.id === savedId && v.year === savedYear);
      if (!vehicle) return;

      isAutoFilling = true;

      const makeSelect = wrapper.querySelector(".vehicle-make");
      const modelSelect = wrapper.querySelector(".vehicle-model");
      const yearSelect = wrapper.querySelector(".vehicle-year");
      const chassisSelect = wrapper.querySelector(".vehicle-chassis");
      const trimSelect = wrapper.querySelector(".vehicle-trim");

      if (!makeSelect || !modelSelect || !yearSelect || !chassisSelect || !trimSelect) return;

      makeSelect.value = vehicle.make;
      makeSelect.dispatchEvent(new Event("change"));

      setTimeout(() => {
        modelSelect.value = vehicle.model;
        modelSelect.dispatchEvent(new Event("change"));

        setTimeout(() => {
          yearSelect.value = vehicle.year;
          yearSelect.dispatchEvent(new Event("change"));

          setTimeout(() => {
            chassisSelect.value = vehicle.chassis;
            chassisSelect.dispatchEvent(new Event("change"));

            const trimValue = vehicle.trim || "Default";

            setTimeout(() => {
              const option = [...trimSelect.options].find(o => o.value === trimValue);
              if (option) {
                option.selected = true;
              }
              isAutoFilling = false;
            }, 200);
          }, 100);
        }, 100);
      }, 100);
    }

    // Initialize each wrapper
    wrappers.forEach(wrapper => {

      //  REMOVED: Guard against re-initializing - allow re-init for header
      // if (wrapper.dataset.vehicleFilterInit === "true") return;
      // wrapper.dataset.vehicleFilterInit = "true";

      // Skip if already initialized THIS execution
      if (wrapper.__vehicleFilterInitialized) return;
      wrapper.__vehicleFilterInitialized = true;

      const yearSelect = wrapper.querySelector(".vehicle-year");
      const makeSelect = wrapper.querySelector(".vehicle-make");
      const modelSelect = wrapper.querySelector(".vehicle-model");
      const chassisSelect = wrapper.querySelector(".vehicle-chassis");
      const trimSelect = wrapper.querySelector(".vehicle-trim");
      const searchBtn = wrapper.querySelector(".vehicle-search-btn");

      // Safety check
      if (!makeSelect || !modelSelect || !yearSelect || !chassisSelect || !trimSelect || !searchBtn) {
        delete wrapper.__vehicleFilterInitialized; // Allow retry
        return;
      }

      function resetSelect(select, placeholder) {
        select.innerHTML = `<option value="">${placeholder}</option>`;
        select.disabled = true;
      }

      function populateSelect(select, values, placeholder) {
  resetSelect(select, placeholder);

  const uniqueValues = [...new Set(values)].filter(v => v);

  // Sort numerically if all values are numeric (e.g. years), otherwise alphabetically
  const isNumeric = uniqueValues.every(v => !isNaN(v) && v !== "");
  if (isNumeric) {
    uniqueValues.sort((a, b) => Number(a) - Number(b));
  } else {
    uniqueValues.sort((a, b) => a.localeCompare(b));
  }

  uniqueValues.forEach(value => {
    const option = document.createElement("option");
    option.value = value;
    option.textContent = value;
    select.appendChild(option);
  });

  if (uniqueValues.length > 0) {
    select.disabled = false;
  }
}

      populateSelect(makeSelect, data.map(v => v.make), "Select Make");

      makeSelect.addEventListener("change", function () {
        resetSelect(modelSelect, "Select Model");
        resetSelect(yearSelect, "Select Year");
        resetSelect(chassisSelect, "Select Chassis");
        resetSelect(trimSelect, "Select Trim");
        if (!this.value) return;

        const filtered = data.filter(v => v.make === this.value);
        populateSelect(modelSelect, filtered.map(v => v.model), "Select Model");
      });

      modelSelect.addEventListener("change", function () {
        resetSelect(yearSelect, "Select Year");
        resetSelect(chassisSelect, "Select Chassis");
        resetSelect(trimSelect, "Select Trim");
        if (!this.value) return;

        const filtered = data.filter(v => v.make === makeSelect.value && v.model === this.value);
        populateSelect(yearSelect, filtered.map(v => v.year), "Select Year");
      });

      yearSelect.addEventListener("change", function () {
        resetSelect(chassisSelect, "Select Chassis");
        resetSelect(trimSelect, "Select Trim");
        if (!this.value) return;

        const filtered = data.filter(v =>
          v.make === makeSelect.value && v.model === modelSelect.value && v.year === this.value
        );
        populateSelect(chassisSelect, filtered.map(v => v.chassis), "Select Chassis");
      });

chassisSelect.addEventListener("change", function () {
  resetSelect(trimSelect, "Select Trim");
  if (!this.value) return;

  const filtered = data.filter(v =>
    v.make === makeSelect.value &&
    v.model === modelSelect.value &&
    v.year === yearSelect.value &&
    v.chassis === this.value
  );

  trimSelect.innerHTML = `<option value="">Select Trim</option>`;
  const seenTrims = new Set();
  filtered.forEach(v => {
    const trimValue = v.trim || "Default";
    if (seenTrims.has(trimValue)) return;
    seenTrims.add(trimValue);
    const option = document.createElement("option");
    option.value = trimValue;
    option.textContent = trimValue;
    option.dataset.id = v.id;
    trimSelect.appendChild(option);
  });

  if (filtered.length > 0) trimSelect.disabled = false;
});

      [yearSelect, makeSelect, modelSelect, chassisSelect, trimSelect].forEach(el => {
        el.addEventListener("change", () => {
          if (!isAutoFilling) userModified = true;
        });
      });

      searchBtn.addEventListener("click", function (e) {
        const currentWrapper = e.target.closest(".vehicle-filter-wrapper") || wrapper;

        const year = String(currentWrapper.querySelector(".vehicle-year").value).trim();
        const make = String(currentWrapper.querySelector(".vehicle-make").value).trim();
        const model = String(currentWrapper.querySelector(".vehicle-model").value).trim();
        const chassis = String(currentWrapper.querySelector(".vehicle-chassis").value).trim();
        const trim = String(currentWrapper.querySelector(".vehicle-trim").value).trim();

        if (!make || !model || !year || !chassis || !trim) {
          const savedVehicle = localStorage.getItem("selectedVehicle");
          const savedYear = localStorage.getItem("selectedYear");

          if (!userModified && savedVehicle && savedYear) {
            const params = new URLSearchParams();
            params.set("vehicle", savedVehicle);
            params.set("year", savedYear);
            const redirectUrl = `/collections/all?${params.toString()}`;
            window.location.href = redirectUrl;
            return;
          }

          alert("Please select full vehicle.");
          return;
        }

        const vehicle = data.find(v =>
          v.year === year &&
          v.make === make &&
          v.model === model &&
          v.chassis === chassis &&
          (v.trim || "Default") === trim
        );

        if (!vehicle) {
          alert("Invalid vehicle selection.");
          return;
        }

        const vehicleId = String(vehicle.id).trim();
        localStorage.setItem("selectedVehicle", vehicleId);
        localStorage.setItem("selectedYear", year);

        const params = new URLSearchParams();
        params.set("vehicle", vehicleId);
        params.set("year", year);
        const redirectUrl = `/collections/all?${params.toString()}`;
        
        window.location.href = redirectUrl;
      });

      applySavedVehicle(wrapper);
    });
  }

  // Ensure DOMContentLoaded
  function setupFilters() {
    if (window.vehicleData) {
      initFilters();
    } else if (!window.vehicleDataLoading) {
      window.vehicleDataLoading = true;
      loadAllVehicleData().then(() => initFilters());
    } else {
      document.addEventListener("vehicleDataReady", initFilters);
    }
  }

  // Run if DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupFilters);
  } else {
    setupFilters();
  }

  // Re-initialize if Shopify dynamically reloads sections
  document.addEventListener("shopify:section:load", setupFilters);

  //  NEW: Polling approach - try to initialize filters every 500ms for first 5 seconds
  // This catches header modals that are in DOM but initially hidden
  let pollCount = 0;
  const maxPolls = 10; // 10 * 500ms = 5 seconds
  
  const pollInterval = setInterval(() => {
    pollCount++;
    
    const wrappers = document.querySelectorAll(".vehicle-filter-wrapper");
    
    // If we find wrappers that haven't been initialized yet, try initializing
    const uninitializedWrappers = Array.from(wrappers).filter(w => !w.__vehicleFilterInitialized);
    
    if (uninitializedWrappers.length > 0 && window.vehicleData) {
      setupFilters();
    }
    
    // Stop polling after max attempts or if we've successfully initialized all wrappers
    if (pollCount >= maxPolls || wrappers.length === 0) {
      clearInterval(pollInterval);
    }
  }, 500);

  //  NEW: Watch for DOM mutations to detect new wrappers
  const observer = new MutationObserver(() => {
    setupFilters();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

})();